module.exports = __webpack_public_path__ + "img/frame.39cc7d43.svg";